import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { CorporateActionsWidgetState } from 'widgets/corpActions/widget/store/CorporateActionsWidgetState';
import {
    buildCorporateActionsConfigSlice,
    CorporateActionsConfigPayloadType,
} from 'widgets/corpActions/widget/store/config/configSlice';

const { reducer: configReducer } = buildCorporateActionsConfigSlice();

const widgetStateReducer = combineReducers<CorporateActionsWidgetState>({
    config: configReducer,
});

export const corporateActionsWidgetsReducer = createWidgetsReducer<
    CorporateActionsWidgetState,
    CorporateActionsConfigPayloadType
>(WidgetType.CORPORATE_ACTIONS, widgetStateReducer);
